import pako from "pako";

export const gzippedBase64ToString = async (
  stream?: string
): Promise<string | null> => {
  if (!stream) return null;

  try {
    const compressedData = Uint8Array.from(atob(stream), (c) =>
      c.charCodeAt(0)
    );
    const decompressed = pako.ungzip(compressedData, { to: "string" });
    return decompressed;
  } catch (error) {
    console.error("Error decompressing HTML content:", error);
    return null;
  }
};
